import React from 'react';
import Monitor from "../components/Monitor";
import ErrorBoundary from "../components/ErrorBoundary";

const MonitorPage: React.FC = () => {
  return (
    <div className="monitor-page">
      <ErrorBoundary>
        <Monitor />
      </ErrorBoundary>
    </div>
  );
};

export default MonitorPage; 